import React, { Fragment, useEffect, useState } from "react";
import {
  Outlet,
  Link,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { Zoom } from "react-awesome-reveal";

import { useDispatch, useSelector } from "react-redux";
import { error } from "jquery";
import { Alert, Snackbar, Tooltip, useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobeAfrica,
  faHeadset,
  faHome,
  faLocationDot,
  faMapLocationDot,
  faMoneyBill,
  faPhone,
  faQuestionCircle,
  faRoute,
  faSignsPost,
  faStar,
  faUser,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { setLanguage } from "../data/languageSlice";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faSquareInstagram,
  faSquareXTwitter,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
// import { fetchLayout } from "../data/layoutSlice";

const Layout = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1023px)");
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [showButton, setShowButton] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chainCode = queryParams.get("chainCode");

  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.language);

  const languages = [
    {
      code: "en",
      name: t("languages.en"),
      country: t("countries.en"),
      countryCode: "US",
    },
    {
      code: "fr",
      name: t("languages.fr"),
      country: t("countries.fr"),
      countryCode: "FR",
    },
    {
      code: "es",
      name: t("languages.es"),
      country: t("countries.es"),
      countryCode: "ES",
    },
    {
      code: "it",
      name: t("languages.it"),
      country: t("countries.it"),
      countryCode: "IT",
    },
    {
      code: "de",
      name: t("languages.de"),
      country: t("countries.de"),
      countryCode: "DE",
    },
    {
      code: "cn",
      name: t("languages.cn"),
      country: t("countries.cn"),
      countryCode: "CN",
    },
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    dispatch(setLanguage(langCode));
    setViewLanguage(true);

    // Update URL with new language
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("lang", langCode);
    navigate(`${location.pathname}?${newQueryParams.toString()}`, {
      replace: true,
    });
  };

  // Sync i18n language with Redux on mount and when language changes
  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language).catch((err) => {
        console.error("Failed to change language:", err);
      });
    }
  }, [language, i18n]);

  // Get current language info
  const currentLang =
    languages.find((lang) => lang.code === (i18n.language || language)) ||
    languages[0];
  const configuration = useSelector(
    (state) => state.configuration.configuration
  );
  // const { layoutData, loading, error } = useSelector(
  //   (state) => state.layoutData
  // );
  const [scrolled, setScrolled] = useState(false);
  // useEffect(() => {
  //   dispatch(fetchLayout());
  // }, [dispatch]);

  useEffect(() => {
    const checkScroll = () => {
      // Convert 70vh to pixels
      const triggerHeight = window.innerHeight * 0.2;
      const triggerHeight2 = window.innerHeight * 0.1;

      if (window.scrollY > triggerHeight) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
      if (window.scrollY > triggerHeight2) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", checkScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", checkScroll);
    };
  }, []);
  const [isVisible, setIsVisible] = useState(false);
  const [view1, setView1] = useState(false);
  const [view2, setView2] = useState(false);
  const [view3, setView3] = useState(false);
  // Function to handle the scroll to top action
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Function to check scroll position
  const checkScrollTop = () => {
    if (!isVisible && window.pageYOffset > 400) {
      setIsVisible(true);
    } else if (isVisible && window.pageYOffset <= 400) {
      setIsVisible(false);
    }
  };

  // Listen for scroll events
  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  });
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  // const { loadingNewsletter, errorNewsletter } = useSelector(
  //   (state) => state.newsLetter
  // );
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the menu open and closed
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const [email, setEmail] = useState("");

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "ar" : "en";
    dispatch(setLanguage(newLanguage));
    window.location.pathname = `/${newLanguage}${window.location.pathname.substring(
      3
    )}`;
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    // Check if the window's scroll position is greater than a certain value (e.g., 50px)
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [viewCurrency, setViewCurrency] = useState(true);
  const [viewLanguage, setViewLanguage] = useState(true);

  // mobile menu
  const [isMenuActive, setIsMenuActive] = useState(false);

  // Toggle menu handler
  const handleMenuToggle = () => {
    setIsMenuActive(!isMenuActive);
  };
  const [isDestinationsActive, setIsDestinationsActive] = useState(false);

  const handleDestinationsClick = (e) => {
    e.preventDefault();
    setIsDestinationsActive(!isDestinationsActive);
  };
  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <>
      {" "}
      {/* <div
        className={`currencyMenu  js-currencyMenu ${
          viewCurrency && "is-hidden"
        }`}
      >
        <div
          className="currencyMenu__bg"
          data-x-click="currency"
          onClick={() => setViewCurrency(true)}
        ></div>

        <div className="currencyMenu__content bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            <div className="text-20 fw-500 lh-15">Select your currency </div>
            <button className="pointer" onClick={() => setViewCurrency(true)}>
              <i className="icon-close"></i>
            </button>
          </div>

          <div className="modalGrid px-30 py-30 sm:px-15 sm:py-15">
            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  United States dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">USD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Australian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">AUD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Brazilian real{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BRL </span>- R$
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Bulgarian lev{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BGN </span>- лв.
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Canadian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">CAD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  United States dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">USD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Australian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">AUD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Brazilian real{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BRL </span>- R$
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Bulgarian lev{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BGN </span>- лв.
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Canadian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">CAD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  United States dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">USD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Australian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">AUD </span>- $
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Brazilian real{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BRL </span>- R$
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Bulgarian lev{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">BGN </span>- лв.
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Canadian dollar{" "}
                </div>
                <div className="text-14 lh-15 mt-5">
                  <span className="js-title">CAD </span>- $
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className={`langMenu  js-langMenu ${viewLanguage && "is-hidden"}`}>
        <div
          className="langMenu__bg"
          onClick={() => setViewLanguage(true)}
        ></div>

        <div className="langMenu__content bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            <div className="text-20 fw-500 lh-15">
              {t("common.selectLanguage")}
            </div>
            <button className="pointer" onClick={() => setViewLanguage(true)}>
              <i className="icon-close"></i>
            </button>
          </div>

          <div className="modalGrid px-30 py-30 sm:px-15 sm:py-15">
            {languages.map((lang) => (
              <div
                key={lang.code}
                className={`modalGrid__item js-item ${(i18n.language || language) === lang.code ? "active" : ""
                  }`}
                onClick={() => handleLanguageChange(lang.code)}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    (i18n.language || language) === lang.code
                      ? "#f0f0f0"
                      : "transparent",
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  if ((i18n.language || language) !== lang.code) {
                    e.currentTarget.style.backgroundColor = "#f8f8f8";
                  }
                }}
                onMouseLeave={(e) => {
                  if ((i18n.language || language) !== lang.code) {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                <div className="py-10 px-15 sm:px-5 sm:py-5">
                  <div className="text-15 lh-15 fw-500 text-dark-1 d-flex items-center">
                    <ReactCountryFlag
                      countryCode={lang.countryCode}
                      svg
                      style={{
                        width: "20px",
                        height: "20px",
                        marginRight: "10px",
                      }}
                      title={lang.country}
                    />
                    {lang.name}
                    {(i18n.language || language) === lang.code && (
                      <span className="ms-auto text-primary">✓</span>
                    )}
                  </div>
                  <div className="text-14 lh-15 mt-5 js-title">
                    {lang.country}
                  </div>
                </div>
              </div>
            ))}

            {/* <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Türkçe </div>
                <div className="text-14 lh-15 mt-5 js-title">Turkey </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Español </div>
                <div className="text-14 lh-15 mt-5 js-title">España </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Français{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">France </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Italiano{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">Italia </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">English </div>
                <div className="text-14 lh-15 mt-5 js-title">
                  United States{" "}
                </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Türkçe </div>
                <div className="text-14 lh-15 mt-5 js-title">Turkey </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Español </div>
                <div className="text-14 lh-15 mt-5 js-title">España </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Français{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">France </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Italiano{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">Italia </div>
              </div>
            </div> */}

            {/* <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">English </div>
                <div className="text-14 lh-15 mt-5 js-title">
                  United States{" "}
                </div>
              </div>
            </div> */}

            {/* <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Türkçe </div>
                <div className="text-14 lh-15 mt-5 js-title">Turkey </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">Español </div>
                <div className="text-14 lh-15 mt-5 js-title">España </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Français{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">France </div>
              </div>
            </div>

            <div className="modalGrid__item js-item">
              <div className="py-10 px-15 sm:px-5 sm:py-5">
                <div className="text-15 lh-15 fw-500 text-dark-1">
                  Italiano{" "}
                </div>
                <div className="text-14 lh-15 mt-5 js-title">Italia </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <header
        className={`header mt-10 -type-9 js-header ${isSticky ? "bg-dark-1 is-sticky" : ""
          }`}
      >
        <div className="header__container container">
          <div className="row justify-between items-center ">
            <div className="col-auto">
              <div className="d-flex items-center">
                <Link
                  to={`/?lang=${language}&chainCode=${chainCode}`}
                  className="header-logo mr-20"
                  data-x="header-logo"
                  data-x-toggle="is-logo-dark"
                >
                  {window.location.pathname.includes("/booking") ||
                    window.location.pathname.includes("/contact-us") ||
                    window.location.pathname.includes("/checkout") ||
                    window.location.pathname.includes("/add-extra") ||
                    window.location.pathname.includes("/help-center") ||
                    window.location.pathname.includes("/signup") ||
                    window.location.pathname.includes("/signin") ||
                    window.location.pathname.includes("/cruise-type") ||
                    window.location.pathname.includes("/cruises-details") ? (
                    <img
                      src={`${configuration?.companyLogo &&
                        configuration?.companyLogo !==
                        "https://cdn.nilecabins.info/images/uploads/"
                        ? configuration?.companyLogo
                        : "nilecabinscom.png"
                        }`}
                      alt="logo icon"
                    />
                  ) : (
                    <img
                      src={`${configuration?.companyLogo &&
                        configuration?.companyLogo !==
                        "https://cdn.nilecabins.info/images/uploads/"
                        ? configuration?.companyLogo
                        : "nilecabinscomwhite.png"
                        }`}
                      alt="logo icon"
                    />
                  )}
                </Link>
              </div>
            </div>

            {/* <div className="col-auto">
              <div className="d-flex items-center">
                <div className="col-auto">
                  <div className="row x-gap-15 items-center jusify-between">
                    <div className="col-auto">
                      <div className="row x-gap-20 items-center ">
                       

                        <div className="col-auto  md:d-none">
                          <button
                            className={`d-flex items-center text-14   ${window.location.pathname.includes("/booking") ||
                              window.location.pathname.includes(
                                "/contact-us"
                              ) ||
                              window.location.pathname.includes("/checkout") ||
                              window.location.pathname.includes("/add-extra") ||
                              window.location.pathname.includes(
                                "/help-center"
                              ) ||
                              window.location.pathname.includes("/signup") ||
                              window.location.pathname.includes("/signin") ||
                              window.location.pathname.includes(
                                "/cruise-type"
                              ) ||
                              window.location.pathname.includes(
                                "/cruises-details"
                              )
                              ? "text-primary"
                              : "text-white"
                              }`}
                            onClick={() => setViewLanguage(!viewLanguage)}
                          >
                            <ReactCountryFlag
                              countryCode={currentLang.countryCode}
                              svg
                              style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                              }}
                              title={currentLang.country}
                            />
                            <span className="js-language-mainTitle">
                              {currentLang.code.toUpperCase()}{" "}
                            </span>
                            <i className="icon-chevron-sm-down text-7 ml-15"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`d-none xl:d-flex x-gap-20 items-center pl-20  ${window.location.pathname.includes("/booking") ||
                    window.location.pathname.includes("/contact-us") ||
                    window.location.pathname.includes("/checkout") ||
                    window.location.pathname.includes("/add-extra") ||
                    window.location.pathname.includes("/help-center") ||
                    window.location.pathname.includes("/signup") ||
                    window.location.pathname.includes("/signin") ||
                    window.location.pathname.includes("/cruise-type") ||
                    window.location.pathname.includes("/cruises-details")
                    ? "text-primary"
                    : "text-white"
                    }`}
                  data-x="header-mobile-icons"
                  data-x-toggle="text-white"
                >
                  <div>
                    <div className="col-auto  ">
                      <button
                        className="d-none xl:d-flex items-center text-14  "
                        onClick={() => setViewLanguage(!viewLanguage)}
                      >
                        <ReactCountryFlag
                          countryCode={currentLang.countryCode}
                          svg
                          style={{
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                          }}
                          title={currentLang.country}
                        />
                        <span className="js-language-mainTitle">
                          {currentLang.code.toUpperCase()}{" "}
                        </span>
                        <i className="icon-chevron-sm-down text-7 ml-15"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </header>
      <main>
        {" "}
        <Outlet />
      </main>
      {/* <section
        className="layout-pt-md layout-pb-md bg-blue-1 newsletter  "
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="container">
          <div className="row y-gap-30 justify-between items-center ">
            <div className="col-auto">
              <div className="d-flex y-gap-20 flex-wrap items-center">
                <div className="icon-newsletter text-60 sm:text-40 text-white"></div>

                <div className="ml-30">
                  <h4 className="text-26 text-white fw-600">
                    Your BookingNile.com Adventure Awaits!
                  </h4>
                  <div className="text-white">
                    Sign up and we'll sail you to the best deals on
                    unforgettable cruises!
                  </div>
                </div>
              </div>
            </div>

            <form
              onSubmit={handleSubmit}
              className="col-auto"
              style={{ zIndex: 1 }}
            >
              <div className="single-field -w-410 d-flex x-gap-10 y-gap-20">
                <div>
                  <input
                    className="bg-white h-60"
                    type="text"
                    placeholder="Your Email"
                  />
                </div>

                <div>
                  <button
                    type="submit"
                    on
                    className="button -md h-60 bg-yellow-1 text-dark-1"
                  >
                    Subscribe{" "}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="  effect-cls">
          <div
            className="cloud bg-size"
            style={{
              backgroundImage: `url(cloud-real.png)`,
              backgroundSize: "100% 180%",
              backgroundPosition: "center center",
              backgroundRepeat: "space",
              display: "block",
              animation: "moveClouds 60s linear infinite",
              animationDelay: "0s",
              position: "absolute",
              top: 0,
              height: "100%",
            }}
          >
            <img src="cloud-real.png" alt="" className="bg-img" />
          </div>
        </div>
        <style>
          {`
          @keyframes moveClouds {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
        `}
        </style>
      </section> */}
      <footer
        className="footer -type-1 text-white bg-blue-1"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="container">
          <div className="py-20 px-0 border-top-white-15 last-footer">
            <div className="footer-bottom row align-items-center justify-content-between  ">
              <div className="col-lg-9">
                <div className="d-flex items-start">
                  © {currentYear} {configuration?.companyName} |{" "}
                  {t("common.allRightsReserved")}
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="d-flex items-center justify-center">
                  <div className="logos">
                    <img
                      src="bookingnile.png"
                      className="me-2"
                      style={{ height: "auto", width: "150px" }}
                      alt=""
                    />
                    <img
                      className="me-2"
                      src="tit-logo.png"
                      alt="titsolutions logo"
                    />
                    <img
                      className="me-2"
                      src="be-closer.png"
                      alt="be-closer  logo"
                    />
                    <img src="nut-logo.png" alt="nut travel logo" />
                  </div>
                </div>
              </div> */}

              <div className="col-lg-3 ">
                <div className="text-right">
                  {t("common.poweredBy")}{" "}
                  <Link to="https://titegypt.com" target="_blank">
                    T.I.T Solutions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Layout;
